import { H5, H6 } from "@sellar-io/components";
import dayjs from "dayjs";
import { useMatch } from "react-router";
import { ListElement } from "../../components";
import * as ROUTES from "../../constants/routes";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import { pluralize } from "@sellar-io/common";
import { SellarDistributionCollectionListResponseType } from "@sellar-io/api-v2/types";
import { distributionCollectionStatus } from "./DistributionCollectionListItem.shared";

export const DistributionCollectionListItem = ({
  collection,
  type,
}: {
  collection: SellarDistributionCollectionListResponseType["data"][number];
  type: "processing" | "allocated";
}) => {
  const taskDate = useMatch(ROUTES.DISTRIBUTION_DETAILS_PROCESSING.pattern)
    ?.params.taskDate;
  const taskId = useParamAsNumber(
    ROUTES.DISTRIBUTION_DETAILS_ALLOCATED,
    "taskId",
    false,
  );

  const imageURl =
    "https://sellar.imgix.net/sellar-image-assets/sellar-logo-gradient.svg";

  const to =
    type === "allocated"
      ? collection.id === undefined
        ? undefined
        : ROUTES.DISTRIBUTION_DETAILS_ALLOCATED.href({
            taskId: collection.id,
          })
      : ROUTES.DISTRIBUTION_DETAILS_PROCESSING.href({
          taskDate: dayjs(collection.date).format("YYYY-MM-DD"),
        });

  const selected =
    collection.id !== undefined
      ? taskId === collection.id
      : taskDate === dayjs(collection.date).format("YYYY-MM-DD");

  return (
    <ListElement promptText={""} to={to} selected={selected}>
      <img alt={""} src={imageURl} className={"h-12 w-12"} />
      <div className={"space-y-2"}>
        <div className="flex flex-col">
          <H5>{dayjs(collection.date).format("dddd DD MMMM")}</H5>
          <H6>
            {collection.nbOfOrders} {pluralize("order", collection.nbOfOrders)}
          </H6>
        </div>
        <div>
          <div className={"flex flex-wrap gap-2"}>
            {distributionCollectionStatus(collection.status)}
          </div>
        </div>
      </div>
    </ListElement>
  );
};
